const goToThanks = () => {
  // Setup our calendar links
  $('.google-link').attr(
    'href',
    'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20260319T180000Z%2F20260319T190000Z&details=For%20years%2C%20Josh%20has%20been%20building%20toward%20something%20bigger.%20On%20March%2019th%2C%20see%20what%20happens%20when%20it%20all%20comes%20together.%0A%0AWatch%20the%20live%20stream%20event%20here%3A%0Ahttps%3A%2F%2Fwww.josh.ai%2Fkeynote-2026&location=https%3A%2F%2Fwww.josh.ai%2Fkeynote-2026&text=Josh.ai%20Keynote%20Event',
  );
  $('.outlook-link').attr(
    'href',
    'https://outlook.live.com/calendar/0/action/compose?allday=false&body=For%20years%2C%20Josh%20has%20been%20building%20toward%20something%20bigger.%20On%20March%2019th%2C%20see%20what%20happens%20when%20it%20all%20comes%20together.%0A%0AWatch%20the%20live%20stream%20event%20here%3A%0Ahttps%3A%2F%2Fwww.josh.ai%2Fkeynote-2026&enddt=2026-03-19T13%3A00%3A00&location=https%3A%2F%2Fwww.josh.ai%2Fkeynote-2026&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2026-03-19T12%3A00%3A00&subject=Josh.ai%20Keynote%20Event',
  );
  $('.apple-link').attr(
    'href',
    'https://stripo.email/storage/ics/2026/3/ics_joshai-keynote-event-2026-03-03-233412.ics',
  );

  // Scroll to top
  window.scrollTo(0, 0);

  $('.registration, .event_video, .pageHeader, .pageSubHeader').hide();
  $('.registration_thanks').show();
  $('.registration_thanks').css('display', 'flex');
  $('.registration_thanks').css('flex-direction', 'column');
  $('.registration_thanks').css('align-items', 'center');
  $('.registration_thanks').css('justify-content', 'center');
  $('.main_content').css('height', '100vh');
  $('.gifBottom').css('position', 'absolute');
  $('.gifBottom').css('bottom', '0');
};

const goToLiveEvent = () => {
  window.location = 'https://youtu.be/0gVKShqKTd4?si=3DZk5ug8WQ7RnHST';
};

// Wait for document ready
$(() => {
  // See if we have any "short circuiting" vars.
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('goto')) {
    const goto = urlParams.get('goto');
    switch (goto) {
      case 'thanks':
        goToThanks();
        break;
      case 'event':
        goToLiveEvent();
        break;
    }
  }

  // Check to see if we need to forward to the event page (8am on March 19, 2026)
  if (
    Date.now() > new Date('2026-03-19 00:00:01') ||
    Date.now() > new Date('2026/03/19 08:00:01')
  ) {
    goToLiveEvent();
  }

  // Handle submitting the registration form.
  $('.registration_form').on('submit', (evt) => {
    // Clear out any previous errors and red borders
    $('.error_message').remove();
    $('.error').removeClass('error');
    let errorMessage = '';

    // Check to make sure our inputs are valid.
    const firstName = $('#first_name').val();
    console.log('first name', firstName);
    if (!firstName || firstName == '') {
      errorMessage = 'First name is required.';
    } else if (firstName.length < 2) {
      errorMessage = 'First name must have at least 2 letters.';
    } else if (firstName.length > 255) {
      errorMessage = "First name can't have over 255 letters.";
    }
    if (errorMessage) {
      $('#first_name')
        .addClass('error')
        .after(`<div class="error_message">${errorMessage}</div>`);
      return false;
    }

    const lastName = $('#last_name').val();
    console.log('last name', lastName);
    if (!lastName || lastName == '') {
      errorMessage = 'Last name is required.';
    } else if (lastName.length < 2) {
      errorMessage = 'Last name must have at least 2 letters.';
    } else if (lastName.length > 255) {
      errorMessage = "Last name can't have over 255 letters.";
    }
    if (errorMessage) {
      $('#last_name')
        .addClass('error')
        .after(`<div class="error_message">${errorMessage}</div>`);
      return false;
    }

    const email = $('#email').val();
    if (!email || email == '') {
      errorMessage = 'Email address required.';
    } else if (
      !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email,
      )
    ) {
      errorMessage = 'Please enter a valid email address.';
    }
    if (errorMessage) {
      $('#email')
        .addClass('error')
        .after(`<div class="error_message">${errorMessage}</div>`);
      return false;
    }

    const about = $('#about').val();
    if (!about || about == '') {
      errorMessage = 'Please select an option.';
    }
    if (errorMessage) {
      $('#about')
        .addClass('error')
        .after(`<div class="error_message">${errorMessage}</div>`);
      return false;
    }

    // Get referral from search params if present
    const referral = new URLSearchParams(window?.location?.search)?.get(
      'referral',
    );

    // Call the API and subscribe to the mailing list.
    $.ajax({
      type: 'POST',
      url: 'https://api.josh.ai/mailchimp/addUser',
      headers: {
        'Content-Type': 'application/json',
      },
      processData: false,
      data: JSON.stringify({
        listID: 'f1abb44a64', // NEW AudienceID For 2026 Keynote
        firstName,
        lastName,
        email,
        otherFields: {
          ABOUT: about, // All caps is how it's set in MailChimp and because this is a pass through, we'll do the same here.
          REFERRAL: referral?.length > 0 ? referral : '', // Add REFERRAL if we have one, otherwise empty string
        },
      }),
      success: (resp) => {
        // Hide our registration page and show the thanks.
        goToThanks();
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(jqXHR);
        if (jqXHR.responseJSON?.title === 'Member Exists') {
          goToThanks();
        } else {
          $('#submit_btn').after(
            `<div class="error_message">${jqXHR?.responseJSON?.detail}</div>`,
          );
        }
      },
      dataType: 'json',
    });

    // Make sure the form submission doesn't refresh the page.
    return false;
  });
});
